/**
 * Shared display-name formatter used by both the server (when minting LiveKit
 * tokens) and the client (when rendering participant tiles). Keeping the
 * implementation in exactly one place guarantees the server and client never
 * disagree on what name to show for a given user.
 *
 * Priority: "First L." → first name → shortCode → username → fallback.
 * Empty / whitespace-only strings are treated the same as missing.
 */
export interface DisplayNameUser {
  firstName?: string | null;
  lastName?: string | null;
  shortCode?: string | null;
  username?: string | null;
}

export function formatUserDisplayName(
  user: DisplayNameUser | null | undefined,
  fallback: string,
): string {
  if (user) {
    const first = user.firstName?.trim();
    const lastInitial = user.lastName?.trim()?.[0];
    if (first && lastInitial) return `${first} ${lastInitial}.`;
    if (first) return first;
    const shortCode = user.shortCode?.trim();
    if (shortCode) return shortCode;
    const username = user.username?.trim();
    if (username) return username;
  }
  return fallback;
}
